import React from 'react';
import { Link } from 'react-router-dom';
import FormItem from './general/formitem.js';

export default class Login extends React.Component
{
    constructor(props)
    {
        super(props);
        this.inputChanged = this.inputChanged.bind(this);
        this.checkboxInputChanged = this.checkboxInputChanged.bind(this);
        this.state = {
            loaded: true,
            success: false,
            formMessage: "",
            validationErrors: [],
            authError: "",
            submissionAttempted: false,
            fromAnon: this.props.anon,
            formData: {
                username: "",
                password: "",
                rememberMe: true
            }
        }
    }
    inputChanged(event)
    {
        var data = this.state.formData;
        data[event.target.name] = event.target.value;
        this.setState({formData: data}, () => this.validate());
    }
    checkboxInputChanged(event)
    {
        var data = this.state.formData;
        data[event.target.name] = event.target.checked;
        this.setState({formData: data});
    }
    validate()
    {
        if (this.state.submissionAttempted)
        {
            var errors = [];
            if (this.state.formData.username.trim() === "")
            {
                errors.push({message: "Username is required.", element: "username"})
            }
            if (this.state.formData.password.trim() === "")
            {
                errors.push({message: "Password is required.", element: "password"})
            }
            this.setState({validationErrors: errors});
            if (errors.length > 0)
            {
                return false;
            }
        }
        return true;
    }
    submitLogin(event)
    {
        event.preventDefault();
        event.persist();
        this.setState({submissionAttempted: true}, () => {
            if (this.validate())
            {
                this.setState({loaded: false});
                this.props.onSubmit(event, (result) => {
                    this.setState({loaded: true, authError: result.message});
                })
            }
        })
    }
    render()
    {
        return (
            <div>
                <h2>Login</h2>
                <div className="lmsform">
                    <div className="lmsformheading">
                        Login to Safety Check
                    </div>
                    <div className="lmsformbody">
                    { this.state.loaded ? (
                        <div>
                            <form className="lmsforminner" method="post" onSubmit={(e) => this.submitLogin(e)}>
                                <FormItem label="Username:" name="username" type="text"
                                    inputChanged={this.inputChanged} value={this.state.username} />
                                <FormItem label="Password:" name="password" type="password"
                                    inputChanged={this.inputChanged} value={this.state.password} />
                                <FormItem label="Remember me" name="rememberMe" type="checkbox" checked={this.state.formData.rememberMe}
                                    inputChanged={this.checkboxInputChanged} value={this.state.rememberMe} />
                                <div className="lmsvalidationerror lmscenter">
                                    <span>{this.state.validationErrors.map((err) =>
                                        <p key={err.element}>{err.message}</p>
                                    )}</span>
                                </div>
                                <div className="lmsvalidationerror lmscenter">
                                        {this.state.authError}
                                </div>
                                <div className="lmsformfooter">
                                    <input type="submit" name="login" value="Login" className="lmsbutton" />
                                </div>
                                <div className="lmscenter">
                                    <Link to="/PasswordReset" className="bodylink">Forgot your password?</Link>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div className="lmscenter">
                            <img src="/images/spinner.svg" alt="loading" />
                        </div>
                    )}
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/login.js